export enum GridBreakpoint {
  xs = 0,
  sm = 600,
  md = 900,
  lg = 1200,
  xl = 1536,
  xxl = 1920,
  xxxl = 2400,
  xxxxl = 2880,
}

export interface GridContainer {
  name: GridContainerName;
  title: GridContainerTitle;
  width: number;
}

export interface GridColumn {
  id: number;
  container: GridContainer[];
  width: number;
  align: string;
}

export interface GridLayout {
  width: GridBreakpoint;
  align: string;
  columns: GridColumn[];
}

export enum GridContainerName {
  detailsContainer = "detailsContainer",
  affectedCustomersContainer = "affectedCustomersContainer",
  alertContainer = "alertContainer",
  mapContainer = "mapContainer",
  postContainer = "postContainer",
  checkListContainer = "checkListContainer",
  documentContainer = "documentContainer",
  assignmentContainer = "assignmentContainer",
}

export enum GridContainerTitle {
  detailsTitle = "Detaljer",
  affectedCustomersTitle = "Berørte",
  alertTitle = "Varsler",
  mapTitle = "Kart",
  postTitle = "Diskusjon",
  checkListTitle = "Sjekkliste",
  documentTitle = "Dokumenter",
  assignmentTitle = "Oppdrag",
}

export const eventGridLayoutName = "eventGridLayout";
export const eventGridLayoutVersion = "1.0.3";

export interface GridLayouts {
  Generell: GridLayout;
  Fellesfeil: GridLayout;
  Planlagt: GridLayout;
}

export const eventGridLayoutGEDefault: GridLayout = {
  width: GridBreakpoint.xxl,
  align: "center",
  columns: [
    {
      id: 1,
      container: [
        {
          title: GridContainerTitle.detailsTitle,
          name: GridContainerName.detailsContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.documentTitle,
          name: GridContainerName.documentContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.assignmentTitle,
          name: GridContainerName.assignmentContainer,
          width: 12,
        }
      ],
      width: 3,
      align: "left",
    },
    {
      id: 2,
      container: [
        {
          title: GridContainerTitle.affectedCustomersTitle,
          name: GridContainerName.affectedCustomersContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.alertTitle,
          name: GridContainerName.alertContainer,
          width: 12,
        },
      ],
      width: 4,
      align: "left",
    },
    {
      id: 3,
      container: [
        {
          title: GridContainerTitle.postTitle,
          name: GridContainerName.postContainer,
          width: 12,
        },
      ],
      width: 5,
      align: "left",
    },
    {
      id: 4,
      container: [],
      width: 3,
      align: "left",
    },
    {
      id: 5,
      container: [],
      width: 3,
      align: "left",
    },
  ],
};

export const eventGridLayoutFFDefault: GridLayout = {
  width: GridBreakpoint.xxl,
  align: "center",
  columns: [
    {
      id: 1,
      container: [
        {
          title: GridContainerTitle.detailsTitle,
          name: GridContainerName.detailsContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.documentTitle,
          name: GridContainerName.documentContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.assignmentTitle,
          name: GridContainerName.assignmentContainer,
          width: 12,
        }
      ],
      width: 3,
      align: "left",
    },
    {
      id: 2,
      container: [
        {
          title: GridContainerTitle.affectedCustomersTitle,
          name: GridContainerName.affectedCustomersContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.alertTitle,
          name: GridContainerName.alertContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.mapTitle,
          name: GridContainerName.mapContainer,
          width: 12,
        },
      ],
      width: 4,
      align: "left",
    },
    {
      id: 3,
      container: [
        {
          title: GridContainerTitle.postTitle,
          name: GridContainerName.postContainer,
          width: 12,
        },
      ],
      width: 5,
      align: "left",
    },
    {
      id: 4,
      container: [],
      width: 3,
      align: "left",
    },
    {
      id: 5,
      container: [],
      width: 3,
      align: "left",
    },
  ],
};

export const eventGridLayoutPADefault: GridLayout = {
  width: GridBreakpoint.xxl,
  align: "center",
  columns: [
    {
      id: 1,
      container: [
        {
          title: GridContainerTitle.detailsTitle,
          name: GridContainerName.detailsContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.documentTitle,
          name: GridContainerName.documentContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.assignmentTitle,
          name: GridContainerName.assignmentContainer,
          width: 12,
        }
      ],
      width: 3,
      align: "left",
    },
    {
      id: 2,
      container: [
        {
          title: GridContainerTitle.affectedCustomersTitle,
          name: GridContainerName.affectedCustomersContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.alertTitle,
          name: GridContainerName.alertContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.mapTitle,
          name: GridContainerName.mapContainer,
          width: 12,
        },
      ],
      width: 4,
      align: "left",
    },
    {
      id: 3,
      container: [
        {
          title: GridContainerTitle.postTitle,
          name: GridContainerName.postContainer,
          width: 12,
        },
        {
          title: GridContainerTitle.checkListTitle,
          name: GridContainerName.checkListContainer,
          width: 12,
        },
      ],
      width: 5,
      align: "left",
    },
    {
      id: 4,
      container: [],
      width: 3,
      align: "left",
    },
    {
      id: 5,
      container: [],
      width: 3,
      align: "left",
    },
  ],
};
